import { render } from "./hazardBasisEdit.vue?vue&type=template&id=5e25c53e&scoped=true"
import script from "./hazardBasisEdit.vue?vue&type=script&lang=js"
export * from "./hazardBasisEdit.vue?vue&type=script&lang=js"

import "./hazardBasisEdit.vue?vue&type=style&index=0&id=5e25c53e&lang=scss&scoped=true"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e25c53e"]])

export default __exports__